import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-item-dropdown',
  templateUrl: './item-dropdown.component.html',
  styleUrls: ['./item-dropdown.component.scss']
})
export class ItemDropdownComponent {
  @Input() items: { text: string, value: number }[] = [];
  @Output() handleSubmitResponse = new EventEmitter();
  @Input() canChangeStyle: any;
  @Input() clientConfigurationData: any;
  styleSheet: CSSStyleSheet | undefined;
  @ViewChild('myDropdown') myDropdown!: NgbDropdown;
  DATA: any;


  ngOnInit(): void {
    if (this.canChangeStyle) {
      this.DATA = this.clientConfigurationData;
      this.fnSetStyles();
    } else {
      this.fnSetDefaultStyles();
    }
  }

  onItemSelect(data: any) {
    this.handleSubmitResponse.emit(data);
    this.myDropdown.close();
  }

  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`.date-dropdown-button {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    this.styleSheet.insertRule(`.label-color {
      color: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

    this.styleSheet.insertRule(`.dropdown-list input[type=radio] {
      accent-color: `+ this.DATA.PrimaryColor + ` !important;	
    }`);
  }

  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;
    this.styleSheet.insertRule(`.date-dropdown-button {
      background: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.label-color {
      color: `+ '#156087' + ` !important;	
    }`);

    this.styleSheet.insertRule(`.dropdown-list input[type=radio] {
      accent-color: `+ '#156087' + ` !important;	
    }`);
  }
}
